import { useCallback } from 'react';
import analyticsAPI from '@/lib/api/analytics';

type EventCategory = 'navigation' | 'interaction' | 'conversion' | string;

interface TrackOptions {
  characterId?: number;
  sessionId?: string;
}

export function useTrackEvent() {
  const trackEvent = useCallback(async (
    eventType: string,
    eventCategory: EventCategory,
    eventData?: Record<string, unknown>,
    opts?: TrackOptions
  ) => {
    try {
      const sid = opts?.sessionId || (typeof window !== 'undefined' ? sessionStorage.getItem('__analytics_session_id__') || undefined : undefined);
      const payload = {
        event_type: eventType,
        event_category: eventCategory,
        event_data: eventData,
        session_id: sid,
        character_id: opts?.characterId,
        page_url: typeof window !== 'undefined' ? `${window.location.pathname}${window.location.search}` : undefined,
        referrer: typeof document !== 'undefined' ? (document.referrer || undefined) : undefined,
      } as any;
      await analyticsAPI.events.track(payload);
    } catch {
      // intentionally ignore analytics errors
    }
  }, []);

  return trackEvent;
}

export default useTrackEvent;


